import ProductTraditionalDiscountMessage, {
  ProductTraditionalDiscountMessageProps,
} from './ProductTraditionalDiscountMessage'
export default ProductTraditionalDiscountMessage
export { ProductTraditionalDiscountMessage }
export type { ProductTraditionalDiscountMessageProps }
